import script from "./TeamLabelComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./TeamLabelComponent.vue?vue&type=script&setup=true&lang=js"

import "./TeamLabelComponent.vue?vue&type=style&index=0&id=5855676e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5855676e"]])

export default __exports__